import { render, staticRenderFns } from "./ModalInteligenciaTerritorialRestricoesSocioambientais.vue?vue&type=template&id=eaa7ea56&lang=pug"
import script from "./ModalInteligenciaTerritorialRestricoesSocioambientais.vue?vue&type=script&lang=js"
export * from "./ModalInteligenciaTerritorialRestricoesSocioambientais.vue?vue&type=script&lang=js"
import style0 from "./ModalInteligenciaTerritorialRestricoesSocioambientais.vue?vue&type=style&index=0&id=eaa7ea56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports